import React, { useEffect, useState } from "react";
import "./Sidebar.scss";
import { Link, useLocation } from "react-router-dom"; // Added useLocation
import { Menu } from "../menu/Menu";
import Image from "../../../components/image/Image";
import { AppIcons } from "../../../data/appIcons";
// import { hasPermission } from "../../../utils/AuthorizeNavigation/authorizeNavigation";
import { getNativationByLogin } from "../../../lib/authenticationLibrary";

const Sidebar = (props) => {
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [authorizeMenu, setAuthorizeMenu] = useState();
  const location = useLocation(); // Added to get current path

  const handleClick = (menu) => {
    if (selectedMenu === menu) {
      setSelectedMenu(null); // Remove class if same menu clicked again
    } else {
      setSelectedMenu(menu); // Add class to the clicked menu
    }
  };

  useEffect(() => {
    setAuthorizeMenu(getNativationByLogin(Menu));
  }, []);

  // Added to set selectedMenu based on current route
  useEffect(() => {
    if (!authorizeMenu) return;
    for (const menuItem of authorizeMenu) {
      if (menuItem.navigationPath === location.pathname) {
        setSelectedMenu(menuItem.id);
        return;
      }
      if (menuItem.children) {
        for (const sub of menuItem.children) {
          if (sub.navigationPath === location.pathname) {
            setSelectedMenu(menuItem.id);
            return;
          }
        }
      }
    }
    setSelectedMenu(null);
  }, [location.pathname, authorizeMenu]);

  return (
    <>
      <div className="sidebar-section">
        <nav className="sidebar">
          <div className="main-menus">
            <Link to={"/"} className="sidebar-brand">
              <Image imagePath={AppIcons.logoImage}></Image>
            </Link>
            <div className="sidebar-menu">
              <ul className="sidebar-menu-list">
                {authorizeMenu &&
                  authorizeMenu.map((menuItem, index) => (
                    <>
                      {menuItem.children ? (
                        <>
                          <li
                            key={index}
                            className={
                              selectedMenu === menuItem.id
                                ? "menu-item active-menu"
                                : "menu-item"
                            }
                            onClick={() => handleClick(menuItem.id)}
                          >
                            <Link
                              to={menuItem.navigationPath}
                              className="menu-arrow"
                            >
                              <i className={menuItem.iconClass}></i>
                              <span>{menuItem.mainMenu}</span>
                            </Link>
                            <ul className="sidebar-dropdown">
                              {menuItem.children.map((subMenu, index) => (
                                <li
                                  className={
                                    subMenu.navigationPath === location.pathname
                                      ? "dropdown-menus active" // Added active class for submenu
                                      : "dropdown-menus"
                                  }
                                  key={index}
                                >
                                  <Link to={subMenu.navigationPath}>
                                    <i
                                      className={subMenu.iconClass}
                                      style={{ color: subMenu.color }}
                                    ></i>
                                    <span>{subMenu.submenuItem}</span>
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </li>
                        </>
                      ) : (
                        <>
                          <li
                            key={index}
                            className={
                              selectedMenu === menuItem.id
                                ? "menu-item active-menu"
                                : "menu-item"
                            }
                            onClick={() => handleClick(menuItem.id)}
                          >
                            <Link to={menuItem.navigationPath}>
                              <i
                                className={menuItem.iconClass}
                                style={{ color: menuItem.color }}
                              ></i>
                              <span>{menuItem.mainMenu}</span>
                            </Link>
                          </li>
                        </>
                      )}
                    </>
                  ))}
              </ul>
              <div className="bottom-menu">
                Chem Index <br /> &copy; {new Date().getFullYear()} All Right
                Reserved.
              </div>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Sidebar;